import { createApp, h } from 'vue'
import axios from 'axios'
import LpApp from '../components/lp_gym01/LpApp'

document.addEventListener('DOMContentLoaded', () => {
  const el = document.getElementById('lp_gym01_app')
  const props = JSON.parse(el.getAttribute('data-props')) || {}

  axios.defaults.headers.common['X-CSRF-Token'] =
    document.querySelector('meta[name="csrf-token"]').getAttribute('content')

  createApp({
    render: () => h(LpApp, props)
  }).mount(el)
})
